import type { TutorialCode, VideoReference, VideoTutorial } from '@/api/types';

/** Редакторы в порядке блоков раздела Learn. */
export const TUTORIAL_EDITORS: readonly TutorialCode[] = ['DR', 'CC', 'FC', 'PP'];

/** Подписи платформ — как в прототипе VideoDetail. */
export const TUTORIAL_LABELS: Record<TutorialCode, string> = {
  DR: 'DaVinci Resolve',
  CC: 'CapCut',
  FC: 'Final Cut Pro',
  PP: 'Premiere Pro',
};

const URL_KEYS: Record<TutorialCode, keyof VideoTutorial> = {
  DR: 'dr_url',
  CC: 'cc_url',
  FC: 'fc_url',
  PP: 'pp_url',
};

export interface TutorialItem {
  /** Название туториала; null — без названия, подпись выбирает интерфейс. */
  title: string | null;
  url: string;
}

export interface TutorialGroups {
  /** Все четыре редактора в порядке TUTORIAL_EDITORS, в том числе пустые. */
  editors: Array<{ code: TutorialCode; label: string; items: TutorialItem[] }>;
  /** Произвольные ссылки: название есть, редактор не указан. */
  other: TutorialItem[];
}

/**
 * Туториалы видео по редакторам (VID-1): запись из админки — техника («Speed Ramp») со
 * ссылкой на каждый редактор, поэтому в блок редактора попадает по строке с каждой записи.
 */
export function tutorialGroups(tutorials: VideoReference['tutorials'] | undefined): TutorialGroups {
  const editors = TUTORIAL_EDITORS.map((code) => ({
    code,
    label: TUTORIAL_LABELS[code],
    items: [] as TutorialItem[],
  }));
  const other: TutorialItem[] = [];
  for (const tutorial of tutorials ?? []) {
    const title = tutorial.label?.trim() || null;
    for (const group of editors) {
      const url = tutorial[URL_KEYS[group.code]];
      if (typeof url === 'string' && url) group.items.push({ title, url });
    }
    for (const item of tutorial.custom_tutorials ?? []) {
      if (
        item &&
        typeof item.name === 'string' &&
        typeof item.url === 'string' &&
        item.name &&
        item.url
      ) {
        other.push({ title: item.name, url: item.url });
      }
    }
  }
  return { editors, other };
}

/** Есть ли у видео хотя бы одна ссылка — иначе раздел показывает одну строку «нет туториалов». */
export function hasTutorials(groups: TutorialGroups): boolean {
  return groups.other.length > 0 || groups.editors.some((group) => group.items.length > 0);
}
